(function () {
  function boot(root) {
    if (!root) return;

    var handle = root.getAttribute("data-product-handle");
    if (!handle) return;

    var headlineEl = root.querySelector("[data-sa-ef-headline]");
    var bodyEl = root.querySelector("[data-sa-ef-body]");

    if (!headlineEl || !bodyEl) return;

    fetch("/ai/editorial-forecast?handle=" + encodeURIComponent(handle), {
      method: "GET",
      headers: { accept: "application/json" }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.ok) return;
        if (!data.headline || !data.body) return;

        headlineEl.textContent = data.headline;
        bodyEl.textContent = data.body;

        root.hidden = false;
        root.removeAttribute("hidden");
      })
      .catch(function (err) {
        console.warn("StylinArts editorial forecast failed:", err);
      });
  }

  function init(scope) {
    scope = scope || document;
    var roots = scope.querySelectorAll("[data-sa-editorial-forecast]");
    roots.forEach(boot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    init(e.target || document);
  });
})();